// Correspondance id local → id serveur des entités dont l'id est attribué par l'API
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
// Entités à id numérique dans l'interface : id local négatif
const NEGATIVE_ID_ENTITIES = ['essence', 'occurrence', 'event'];

// Amorcé sur l'heure : unique d'un lancement de l'app à l'autre
let lastLocalNumericId = -Date.now() * 1000;
export const newLocalNumericId = () => --lastLocalNumericId;

export const isLocalId = (entity, id) => {
    if (id === null || id === undefined) return false;
    if (NEGATIVE_ID_ENTITIES.includes(entity)) return typeof id === 'number' && id < 0;
    if (entity === 'tag') return typeof id === 'string';
    return typeof id === 'string' && UUID.test(id);
};

export const createIdMap = (db) => ({
    set: (entity, localId, serverId) => db.idMap.put({ entity, localId: String(localId), serverId }),
    get: async (entity, localId) => (await db.idMap.get([entity, String(localId)]))?.serverId,
    // Id serveur s'il est connu, id tel quel s'il n'est pas local, undefined s'il est local et encore inconnu
    resolve: async (entity, id) => {
        if (!isLocalId(entity, id)) return id;
        const serverId = (await db.idMap.get([entity, String(id)]))?.serverId;
        if (entity === 'tag') return serverId ?? id;
        return serverId;
    }
});
